// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__jg4QZ","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__y722g"};